module.exports = __webpack_public_path__ + "static/media/snow.f42f462a.svg";